import { IScheduledPushes, TScheduledPushStatus } from 'types';
import { createContext } from 'react';

export type TScheduleViewSortBy = '' | 'PushesA-Z' | 'PushesZ-A' | 'Date/Time1-10' | 'Date/Time10-1';
export type TScheduleViewCountOfItems = '12' | '24' | '48';
export type TTypeOfScheduleViewModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'createSchedule'
	| 'editSchedule';

export interface IScheduleViewState {
	scheduledPushes: IScheduledPushes;
	needRefetchSchedules: boolean;
	searchString: string;
	status: TScheduledPushStatus | null;
	sortBy: TScheduleViewSortBy;
	countOfItems: TScheduleViewCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForEdit: string;
	typeOfModalWindow: TTypeOfScheduleViewModalWindow;
}

export const scheduleViewInitialState: IScheduleViewState = {
	scheduledPushes: { count: 0, pushNotifications: [] },
	needRefetchSchedules: false,
	searchString: '',
	status: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForEdit: '',
	typeOfModalWindow: null,
};

export interface IScheduleViewContext extends IScheduleViewState {
	deleteSelectedItem(): void;
	refetchSchedules(value: boolean): void;
	changeSearchString(value: string): void;
	setStatus(value: TScheduledPushStatus | null): void;
	setSortBy(sortBy: TScheduleViewSortBy): void;
	setCountOfItems(count: TScheduleViewCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForEdit(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfScheduleViewModalWindow): void;
}

export const ScheduleViewContext = createContext<IScheduleViewContext>({
	deleteSelectedItem: () => undefined,
	refetchSchedules: () => undefined,
	changeSearchString: () => undefined,
	setStatus: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForEdit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...scheduleViewInitialState,
});
